module.exports = __webpack_public_path__ + "static/media/work-3.7c675365.jpg";